import React, { useEffect, useState, useCallback } from 'react';
import {
  Template,
  Button
} from 'devextreme-react';
import {
  Column,
  ColumnFixing,
} from 'devextreme-react/data-grid';
import { formatMessage } from 'devextreme/localization';
import { Switch } from 'devextreme-react/switch';
import SplitterLayout from 'react-splitter-layout';
import SimpleDataGrid from '../../SimpleDataGrid';
import style from './configurestock.module.scss';
import {
  columnDataGrid,
  columnAttrDataGrid,
} from './columnDataGrid';
import { Popup } from './Popup';
import { isActive } from '../../../utils/functions';
import AddAttrModal from './AddAttrModal';

/** Конфигуратор склада */
const ConfigureStock = (props) => {
  const {
    plantId,
    getInheritTypes,
    saveConfigureStockAttributes,
    saveAvailableOperations,
    getAllOperations,
    delConfigureStockAttribute,
    // createOperation,
    getConfigureStockAttributes,
    getAllAttributes,
    configuratorReducer: {
      operations,
      inheritTypes,
      skuAttributes,
      getSkuAttributes,
      getAvailableOperations,
      saveAvailableOperation,
      saveAttributes
    }
  } = props;

  /** Модальное окно добавления операции */
  // const [openAddOperationModal, setOpenAddOperationModal] = useState(false);

  const [openAddAttrModal, setOpenAddAttrModal] = useState(false);
  const [openDeleteAttrModal, setOpenDeleteAttrModal] = useState(false);
  const [selectedOperation, setSelectedOperation] = useState([]);
  const [selectedAttr, setSelectedAttr] = useState(null);
  const [loading, setLoading] = useState(false)
  const [disabled, setDisabled] = useState(true)

 //#region [side-effects]
 useEffect(() => {
  if (Array.isArray(selectedOperation) && selectedOperation[0]) {
    setDisabled(!isActive(selectedOperation[0].isActive))
  }
},[selectedOperation])

 /** Функционал добавления операции */
// const [createOperationData, setCreateOperationData] = useState(
//   initialCreateData
// );
// const createOperationCb = () => {
//   const { code, title } = createOperationData;
//   if (code && title) createOperation({ code, title, plantId });
//   setCreateOperationData(initialCreateData);
//   setTimeout(() => getAvailableOperations({ plantId }), 1000);
// };

// получаем данные об операциях по номеру склада
useEffect(() => {
  if (!operations || !operations.length) {
    getAllOperations({ plantId });
  }
  if (!inheritTypes.length) {
    getInheritTypes();
  }
}, [operations, inheritTypes, plantId, getInheritTypes, getAllOperations, operations.length]);

// получаем данные атрибутов по выбору операции
useEffect(() => {
  if (selectedOperation.length) {
    getConfigureStockAttributes({
      plantConfigOperationsId: selectedOperation[0].plantConfigOperationsId
    });
  }
}, [getConfigureStockAttributes, selectedOperation]);

useEffect(() => {
  if(saveAttributes.okRequest && !saveAttributes.loading) {
    getConfigureStockAttributes({
      plantConfigOperationsId: selectedOperation[0].plantConfigOperationsId
    });
  }
},[saveAttributes.okRequest, getConfigureStockAttributes, saveAttributes.loading, selectedOperation])

const onAttrInheritSave = useCallback((data) => {
  saveConfigureStockAttributes(data)
},[saveConfigureStockAttributes])

useEffect(() => {
  if (selectedOperation.length) {
    getAllAttributes({
      plantConfigOperationsId: selectedOperation[0].plantConfigOperationsId
    })
  }
}, [selectedOperation, getAllAttributes])
 //#endregion [side-effects]

  const getPlantConfigOperationsId = selectedOperation.length ? selectedOperation[0].plantConfigOperationsId : null;

  // #region [modals]
  const onHidingModalDelAttr = useCallback(() => {
    setOpenDeleteAttrModal(false);
  }, []);
  const onHidingModaAddAttr = useCallback(() => {
    setOpenAddAttrModal(false);
  }, []);
  // const onHidingModaAddOperation = useCallback(() => {
  //   setOpenAddOperationModal(false);
  // }, []);

  const openDeleteModal = useCallback(
    (data) => {
      setSelectedAttr(data.data);
      setOpenDeleteAttrModal(true);
    },
    [setSelectedAttr]
  );

  const onDeleteAttr = () => {
    delConfigureStockAttribute({
      plantOperationAttribsId: selectedAttr.plantOperationAttribsId
    })
  };

  const renderModalDelAttr = (
    <Popup
      open={openDeleteAttrModal}
      onClose={onHidingModalDelAttr}
      title="Удаление связи"
      onAction={onDeleteAttr}
      actionBtnTitle="Удалить"
    >
      <span>
        Удалить связь атрибута
        <b>{` "${selectedAttr && selectedAttr.attribCode}" `}</b>
        {' '}
        с операцией
        <b>
          {` "${selectedOperation && selectedOperation.length
          && formatMessage('production')[
            selectedOperation[0].operationTypeName
          ]}" `}
        </b>
        ?
      </span>
    </Popup>
  );

  /** Функционал добавления операции */
   // const renderModalAddOperation = useMemo(
  //   () => (
  //     <Popup
  //       open={openAddOperationModal}
  //       onClose={onHidingModaAddOperation}
  //       title="Добавить операцию"
  //       onAction={createOperationCb}
  //       actionBtnTitle="Добавить"
  //     >
  //       <div>
  //         <p>Номер операции</p>
  //         <NumberBox
  //           stylingMode="filled"
  //           placeholder="Введите код операции"
  //           // value={}
  //           onValueChanged={({ value }) => {
  //             setCreateOperationData(prev => ({
  //               code: value,
  //               title: prev.title
  //             }));
  //           }}
  //           // width={300}
  //           showClearButton
  //         />
  //       </div>
  //       <div>
  //         <p>Название операции</p>
  //         <TextBox
  //           stylingMode="outlined"
  //           placeholder="Введите название"
  //           // value={''}
  //           onValueChanged={({ value }) => {
  //             setCreateOperationData(prev => ({
  //               code: prev.code,
  //               title: value
  //             }));
  //           }}
  //         />
  //       </div>
  //     </Popup>
  //   ),
  //   [
  //     selectedAttr,
  //     setSelectedAttr,
  //     openAddAttrModal,
  //     // sendSaveAddRole,
  //     renderAttributes,
  //     loading,
  //     skuAttributes
  //   ]
  // );

  // #endregion [modals]
  useEffect(() => {
    if (saveAvailableOperation.okRequest && !saveAvailableOperation.loading) {
      getAllOperations({ plantId });
    }
    setLoading(false)
  }, [saveAvailableOperation.okRequest, getAllOperations, plantId, saveAvailableOperation.loading]);

const statusCellRenderer = ({ data }) => (
    <Switch
      defaultValue={isActive(data.isActive)}
      disabled={loading || getAvailableOperations.loading || saveAvailableOperations.loading}
      onValueChanged={(e) => {
        setLoading(true);
        saveAvailableOperations({
          operationTypeId: data.operationTypeId,
          plantConfigId: plantId,
          isActive: e.value ? 'Y' : 'N'
        });
        setSelectedOperation([{ ...data, isActive: e.value ? 'Y' : 'N' }]);
      }}
    />
  );

  const operationNamesCellRenderer = ({ data }) => (
    <span>
      {formatMessage('production')[data.operationTypeName]
          || data.operationTypeName}
    </span>
  );

  const onSelectOperation = useCallback(({ selectedRowsData }) => {
    const data = selectedRowsData[0];
    setSelectedOperation([data]);
  }, []);

  // #region [Column renderers]
  const renderOperationColumns = columnDataGrid.map((item) => (
    <Column
      dataField={item.dataField}
      key={item.dataField}
      caption={item.caption}
      visible
      width={item.width}
      cellRender={
        item.cellRenderer === 'statusCellRenderer'
          ? statusCellRenderer
          : operationNamesCellRenderer
      }
      dataType={item.dataType}
    />
  ));

  const renderAttrColumns = columnAttrDataGrid.map((item) => (
    <Column
      dataField={item.dataField}
      key={item.dataField}
      caption={item.caption}
      visible
      allowFiltering
      dataType={item.dataType}
      width={item.width}
    />
  ));
  // #endregion [Column renderers]

  // #region [Buttons]
  const renderButtonDelAttr = (data) => (
    <Button
      disabled={disabled || getSkuAttributes.loading}
      type="default"
      stylingMode="text"
      icon="trash"
      onClick={() => openDeleteModal(data)}
    />
  );

  const toolbarButtonAddAttribute = () => (
    <Button
      type="default"
      stylingMode="contained"
      icon="plus"
      text="Добавить"
      elementAttr={{ class: style.buttonAdd }}
      disabled={disabled || getSkuAttributes.loading}
      onClick={() => setOpenAddAttrModal(true)}
    />
  );

   /** Функционал добавления операции */
  // const toolbarButtonAddOperation = () => (
  //   <Button
  //     type="default"
  //     stylingMode="contained"
  //     icon="plus"
  //     text="Добавить"
  //     elementAttr={{ class: style.buttonAdd }}
  //     // disabled={disabledBtn}
  //     onClick={() => setOpenAddOperationModal(true)}
  //   />
  // );
  // #endregion [Buttons]

  // #region [grids]
  const renderOperationList = (
    <SimpleDataGrid
      className="shipment"
      isDataLoading={getAvailableOperations.loading || saveAvailableOperation.loading}
      setStateStoringName="dataGridOperationList"
      keyExpr="operationTypeName"
      visibleButtonDateRangePicker={false}
      visibleSummary={false}
      visibleGroupPanel={false}
      visibleInfoIcon={false}
      visibleSearchPanel={false}
      visibleColumnChooser={false}
      visibleExport={false}
      visibleFilter={false}
      dataSource={operations}
      selectionMode="single"
      // visibleButtonAddButton="toolbarButtonAddOperation"
      onSelectionChanged={onSelectOperation}
    >
      <ColumnFixing enabled />
      {renderOperationColumns}
      {/* <Template
        name="toolbarButtonAddOperation"
        render={toolbarButtonAddOperation}
      /> */}
    </SimpleDataGrid>
  );
  const renderAttrList = (
    <SimpleDataGrid
      className="shipment"
      setStateStoringName="dataGridAttrList"
      keyExpr="attribCode"
      isDataLoading={getSkuAttributes.loading}
      dataSource={skuAttributes}
      visibleFilter={false}
      selectionMode="single"
      visibleButtonAddButton="toolbarButtonAddAttribute"
      visibleGroupPanel={false}
    >
      <ColumnFixing enabled />
      {renderAttrColumns}
      <Column
        cellRender={renderButtonDelAttr}
        width={75}
        fixed
        fixedPosition="right"
      />
      <Template
        name="toolbarButtonAddAttribute"
        render={toolbarButtonAddAttribute}
      />
    </SimpleDataGrid>
  );
  // #endregion [grids]

  return (
    <div className={style.containing}>
      <SplitterLayout>
        <div className={style.containing}>
          <p>
            <b>Список операций</b>
          </p>
          {renderOperationList}
        </div>
        <div className={style.containing}>
          <p>
            <b>Список атрибутов</b>
          </p>
          {renderAttrList}
        </div>
      </SplitterLayout>
      <AddAttrModal
        isOpen={openAddAttrModal}
        onClose={onHidingModaAddAttr}
        onAction={onAttrInheritSave}
        plantConfigOperationsId={getPlantConfigOperationsId}
      />
      {renderModalDelAttr}
      {/* {renderModalAddOperation} */}
    </div>
  );
};

export default ConfigureStock;
